import DOMPurify from 'dompurify';
import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';

const PaymentInformationErrorModal = ({
    showModal,
    closeModal,
    isFirstPaymentError
}: {
    showModal: boolean;
    closeModal: () => void;
    isFirstPaymentError: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const hippoText = {
        firstSubtitle: DOMPurify.sanitize(
            getHippoText('DSS-PAYMENT-INFORMATION-ERROR-FIRST-SUBTITLE')
        ),
        secondSubtitle: DOMPurify.sanitize(
            getHippoText('DSS-PAYMENT-INFORMATION-ERROR-SECOND-SUBTITLE')
        )
    };

    const goToMitTopdanmark = (): void => {
        window.location.href = '/';
    };

    return (
        <div>
            <ModalOverlay isOpen={showModal} id="modal-dialog">
                <ModalDialog closeIconHandler={goToMitTopdanmark}>
                    <div className="u-spacing-inset-l">
                        <div className="u-spacing-inset-l--stretch-max">
                            <h4 className="u-spacing-stack-sm">
                                {isFirstPaymentError
                                    ? getHippoText('DSS-PAYMENT-INFORMATION-ERROR-FIRST-TITLE')
                                    : getHippoText('DSS-PAYMENT-INFORMATION-ERROR-SECOND-TITLE')}
                            </h4>
                            <p
                                className="u-spacing-stack-none"
                                dangerouslySetInnerHTML={{
                                    __html: isFirstPaymentError
                                        ? hippoText.firstSubtitle
                                        : hippoText.secondSubtitle
                                }}
                            />
                        </div>
                        {isFirstPaymentError ? (
                            <Button onClick={closeModal}>
                                {getHippoText('DSS-PAYMENT-INFORMATION-ERROR-TRY-AGAIN')}
                            </Button>
                        ) : (
                            <></>
                        )}
                        <Button theme={'secondary'} onClick={goToMitTopdanmark}>
                            {getHippoText('DSS-PAYMENT-INFORMATION-ERROR-FRONT-PAGE')}
                        </Button>
                    </div>
                </ModalDialog>
            </ModalOverlay>
        </div>
    );
};

export default PaymentInformationErrorModal;
